import React from "react";

export const getFrequentlyAskedQuestions = (isIBC = false) => [
  {
    title: "Como funciona o lance?",
    content: (
      <div>
        <p>
          O lance é uma forma de antecipar sua contemplação. Caso tenha algum
          dinheiro reservado, você pode fazer a oferta, como um adiantamento de
          parcelas. Existem duas opções de lance: fixo ou livre.
        </p>
        <h6>
          <strong>Lance fixo</strong>
        </h6>
        <p>
          Você pode oferecer 20% do valor que está faltando para quitar o seu
          consórcio. Será contemplado aquele que, entre todos, possuir a cota
          mais próxima da cota sorteada pela Loteria Federal.
        </p>
        <h6>
          <strong>Lance livre</strong>
        </h6>
        <p>
          Nesse tipo de lance, você poderá ofertar qualquer valor maior que sua
          parcela mensal. O lance é convertido em percentual e aquele que
          representar o maior valor será considerado vencedor. Em caso de
          empate, a cota contemplada será a mais próxima da sorteada.
        </p>
        <p>
          Você pode ofertar lances fixo e livre para a mesma assembleia! Se
          houver contemplação por lance fixo, o lance livre será descartado, ou
          vice-versa.
        </p>
        <p>
          Ah, você ainda pode usar até 50% do valor do crédito para pagar o
          lance ofertado! São três chances de ser contemplado – por sorteio,
          lance fixo e lance livre. ;)
        </p>
        <p style={{ fontSize: 11 }}>
          <strong>Lembre-se:</strong> os lances podem ser ofertados até as 20h
          do dia anterior da assembleia, por meio da área do cliente ou pela
          Central de Serviços e Relacionamento. Ligue{" "}
          <a href="tel:3004 4000">3004 4000</a> (capitais e regiões
          metropolitanas, com o custo de uma ligação local) ou{" "}
          <a
            href="tel:0800
          702 4000"
          >
            {" "}
            0800 702 4000
          </a>{" "}
          (nas demais regiões do Brasil, a ligação é gratuita).
        </p>
      </div>
    ),
  },
  {
    title: "Posso desistir da compra?",
    content: (
      <div>
        <p>
          Até sete dias a partir da compra do seu Consórcio, você pode desistir
          e receber o valor eventualmente pago. Basta fazer o pedido em
          “cancelamento de contratos”, no rodapé do nosso site.
        </p>
        <p>
          Após os sete dias, você pode fazer o pedido do seu cancelamento, mas
          lembre-se de que, para um grupo de consórcio terminar, leva tempo e,
          por isso, você só receberá seu dinheiro de volta no encerramento do
          grupo ou nos sorteios mensais das assembleias. Lembre-se de que esse
          valor terá um desconto de 10%, conforme previsto no seu contrato de
          adesão.
        </p>
      </div>
    ),
  },
  {
    title: "O que é cobrado na parcela? Pago juros?",
    content: (
      <div>
        <p>
          No Consórcio você não paga juros. Veja para o que o seu dinheiro será
          destinado.
        </p>
        <p>
          <strong>Fundo Comum:</strong> é o valor que será reunido para a compra
          do bem. É desse fundo que tiramos o crédito que será destinado aos
          contemplados e, havendo saldo no encerramento do grupo, será devolvido
          aos consorciados ativos e excluídos.
        </p>
        <p>
          <strong>Fundo de Reserva:</strong> esse fundo é essencial para manter
          a saúde financeira do grupo. O valor é destinado a uma reserva para
          casos imprevistos, como cobrir uma eventual falta de dinheiro no Fundo
          Comum e, havendo saldo no encerramento do grupo, ele será devolvido
          aos consorciados ativos.
        </p>
        <p>
          <strong>Taxa de Administração:</strong> é o valor que a gente cobra
          para administrar seu consórcio. A Taxa de Administração é diferente
          dos juros cobrados em outras modalidades, por isso é bem menor. Ela é
          dividida durante o tempo contratado: um pedacinho em cada parcela.
        </p>
        {!isIBC && (
          <p>
            <strong>Seguro Prestamista:</strong> esse seguro é opcional e
            cobrado a partir da 2ª parcela. Em caso de morte ou invalidez total
            e permanente do consorciado, o seguro quita o saldo devedor do seu
            Consórcio. Trata-se de uma escolha importante para quem quer evitar
            deixar esses gastos pra quem ama.
          </p>
        )}
      </div>
    ),
  },
  {
    title: "O valor do crédito pode ser usado para pagar o lance?",
    content: (
      <div>
        <p>
          Sim. Só aqui na Caixa Seguradora você tem a opção de usar até 50% do
          valor do crédito para pagar o lance ofertado, sem precisar ter
          dinheiro.
        </p>
        <p>
          Se você quiser complementar a oferta com o seu dinheiro, suas chances
          de contemplação aumentam.
        </p>
        <p>
          Após ser contemplado, você terá um novo crédito disponível e pode
          optar por reduzir o valor das parcelas ou o prazo.
        </p>
      </div>
    ),
  },
  {
    title: "Como sei dos resultados das assembleias?",
    content: (
      <div>
        <p>
          Você pode ver no nosso site, em “consórcio”, e, em seguida,
          “assembleias”.
        </p>
        <p>
          Mensalmente acontece uma assembleia que define quem foi contemplado.
          Por isso é importante que você realize o pagamento das suas parcelas
          até o vencimento, para não perder o direito à contemplação.
        </p>
      </div>
    ),
  },
];
